// Angular
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

// Local
import { AuthService } from '@core/auth/auth.service';


export const isLawFirmUserGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.isLawFirmUser;
};
